import ReactPixel from 'react-facebook-pixel';

const facebookPageAnalytics = () => {
    ReactPixel.fbq('track', 'PageView');
};

export default facebookPageAnalytics;
